import React from 'react'
import { useSelector } from 'react-redux'

import SelectFamilyPackage from '@/components/MainFlow/AddSubscriptions/AddFamilyPhoneItem/SelectFamilyPackage'
import FamilyOwner from '@/components/MainFlow/AddSubscriptions/AddFamilyPhoneItem/FamilyOwner'
import FamilyMembers from '@/components/MainFlow/AddSubscriptions/AddFamilyPhoneItem/FamilyMembers'

const FamilyStepsComponent = ({ onClose }) => {
  const formData = useSelector((state) => state.formData)
  
  return (
    <div>
      {formData.familyStep === 'package' && <SelectFamilyPackage onClose={onClose} />}
      {formData.familyStep === 'owner' && <FamilyOwner onClose={onClose} />}
      {formData.familyStep === 'members' && <FamilyMembers onClose={onClose} />}
    </div>
  )
}

export default FamilyStepsComponent
